import React from 'react';
import './styles.css';
import { Typography, Tag, Flex } from 'antd';
import {
  useFilterState,
  useKeypointFilterState,
  useViewLabelFilterState,
} from '../../../hooks/useFilterState';
import { motion, AnimatePresence } from 'framer-motion';
import { AdvancedFilterValue } from '../../../models/advancedFilters';

interface ActiveFiltersProps {
  pendingRemove: AdvancedFilterValue[];
  setPendingRemove: React.Dispatch<React.SetStateAction<AdvancedFilterValue[]>>;
  keypointMode?: boolean;
  viewLabelMode?: boolean;
  onTagPendingRemove?: (tag: AdvancedFilterValue) => void;
}

export default function ActiveFilters({
  pendingRemove,
  setPendingRemove,
  keypointMode = false,
  viewLabelMode = false,
  onTagPendingRemove,
}: ActiveFiltersProps) {
  const { activeTags } = keypointMode
    ? useKeypointFilterState()
    : viewLabelMode
      ? useViewLabelFilterState()
      : useFilterState();

  const handleClose = (removedTag: AdvancedFilterValue) => {
    setPendingRemove(prev => [...prev, removedTag]);
    if (onTagPendingRemove) onTagPendingRemove(removedTag);
  };

  const filteredTags = activeTags.filter(
    (tag: AdvancedFilterValue) =>
      !pendingRemove.some((p: AdvancedFilterValue) => p.uuid === tag.uuid)
  );

  return (
    <div className="active-filters-container">
      {filteredTags.length > 0 ? (
        <Flex vertical gap="small">
          <Typography.Text strong>Active filters</Typography.Text>
          <div className="active-filters-tags">
            <AnimatePresence>
              {filteredTags.map((tag: AdvancedFilterValue) => (
                <motion.span
                  key={tag.uuid}
                  style={{ display: 'inline-block' }}
                  initial={{ scale: 0.8, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  exit={{ opacity: 0, width: 0, scale: 0 }}
                  transition={{ duration: 0.2 }}
                >
                  <Tag
                    closable
                    onClose={e => {
                      e.preventDefault();
                      handleClose(tag);
                    }}
                  >
                    {tag.name}
                  </Tag>
                </motion.span>
              ))}
            </AnimatePresence>
          </div>
        </Flex>
      ) : (
        <Flex align="center" justify="center" style={{ margin: 'auto' }} vertical>
          <Typography.Text type="secondary" strong>
            No active filters
          </Typography.Text>
          <Typography.Text type="secondary">Select filters above to see them here</Typography.Text>
        </Flex>
      )}
    </div>
  );
}
